module.exports = __webpack_public_path__ + "static/media/goal-website.6b36ccd2.svg";